"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
function mockFormEvent() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return {
    target: mockInputTarget(value)
  };
}
exports.mockFormEvent = mockFormEvent;
function mockInputTarget() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var input = document.createElement("input");
  input.value = value;
  return input;
}
exports.mockInputTarget = mockInputTarget;
function mockMouseEvent(sandbox) {
  var preventDefault = sandbox.stub();
  return {
    preventDefault: preventDefault
  };
}
exports.mockMouseEvent = mockMouseEvent;